import { PayloadAction } from "@reduxjs/toolkit";

import { State } from "../types/state";

const setAutosCoordinates = (
  state: State,
  action: PayloadAction<State["cards"]["data"]>
) => {
  state.cards.data = action.payload;
};

export default setAutosCoordinates;
